import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, Typography, Card, CardContent, Container } from "@mui/material";
import SystemExplanationsTap from "./SystemExplanationsTap/SystemExplanationsTap";
import SystemExplanationsImagesVideosTap from "./SystemExplanationsImagesVideosTap";
import WebsitePlansTap from "./WebsitePlansTap";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import DescriptionIcon from "@mui/icons-material/Description";
import PermMediaIcon from "@mui/icons-material/PermMedia";

const WebsiteDashboardPage = () => {
  const [tabIndex, setTabIndex] = useState(() => {
    return parseInt(localStorage.getItem("tabIndex"), 10) || 0;
  });

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    localStorage.setItem("tabIndex", newValue);
  };

  useEffect(() => {
    const savedTabIndex = parseInt(localStorage.getItem("tabIndex"), 10);
    if (savedTabIndex >= 0 && savedTabIndex <= 2) {
      setTabIndex(savedTabIndex);
    }
  }, []);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Card elevation={3} sx={{ mb: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <CardContent>
          <Typography variant="h4" sx={{ color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
            <DashboardIcon sx={{ fontSize: 40 }} />
            لوحة تحكم الموقع الإلكتروني
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.9)', mt: 1 }}>
            إدارة المحتوى والخطط والشروحات
          </Typography>
        </CardContent>
      </Card>

      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <Tabs 
          value={tabIndex} 
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            bgcolor: '#f5f5f5',
            '& .MuiTab-root': {
              fontSize: '1rem',
              fontWeight: 'bold',
              minHeight: 72,
              transition: 'all 0.3s',
              '&:hover': {
                bgcolor: '#e3f2fd',
              },
              '&.Mui-selected': {
                bgcolor: 'white',
                color: '#1976d2',
              }
            }
          }}
        >
          <Tab 
            label="الخطط المعروضة" 
            icon={<LocalOfferIcon />} 
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab 
            label="شروحات النظام" 
            icon={<DescriptionIcon />} 
            iconPosition="start"
            sx={{ gap: 1 }}
          />
          <Tab 
            label="الصور/الفيديوهات" 
            icon={<PermMediaIcon />} 
            iconPosition="start"
            sx={{ gap: 1 }}
          />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tabIndex === 0 && (
            <Box sx={{ 
              animation: 'fadeIn 0.5s',
              '@keyframes fadeIn': {
                from: { opacity: 0, transform: 'translateY(10px)' },
                to: { opacity: 1, transform: 'translateY(0)' }
              }
            }}>
              <WebsitePlansTap />
            </Box>
          )}
          {tabIndex === 1 && (
            <Box sx={{ 
              animation: 'fadeIn 0.5s',
              '@keyframes fadeIn': {
                from: { opacity: 0, transform: 'translateY(10px)' },
                to: { opacity: 1, transform: 'translateY(0)' }
              }
            }}>
              <SystemExplanationsTap />
            </Box>
          )}
          {tabIndex === 2 && (
            <Box sx={{ 
              animation: 'fadeIn 0.5s',
              '@keyframes fadeIn': {
                from: { opacity: 0, transform: 'translateY(10px)' },
                to: { opacity: 1, transform: 'translateY(0)' }
              }
            }}>
              <SystemExplanationsImagesVideosTap />
            </Box>
          )}
        </Box>
      </Card>
    </Container>
  );
};

export default WebsiteDashboardPage;
